var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "operation-buttons" },
    [
      _vm.showCancel
        ? _c("el-button", { on: { click: _vm.handleCancel } }, [_vm._v("取消")])
        : _vm._e(),
      _vm.showSaveDraft
        ? _c("el-button", { on: { click: _vm.handleSaveDraft } }, [
            _vm._v("保存草稿"),
          ])
        : _vm._e(),
      _vm.showPrev && !_vm.isFirstStep
        ? _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handlePrev } },
            [_vm._v("上一步")]
          )
        : _vm._e(),
      _vm.showNext && !_vm.isLastStep
        ? _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleNext } },
            [_vm._v("下一步")]
          )
        : _vm._e(),
      _vm.showSubmit
        ? _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v("提交审核")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }